export default __webpack_public_path__ + "static/media/swiper_2.90f5b531.png";